define([
    '../slide'
], function (SlideComponent) {
    'use strict';

    /**
     * @class SlideGroupComponent
     * @extends {SlideComponent}
     * @inheritDoc
     */
    return SlideComponent.extend({
        /**
         * @param {Element} slideEl element to scrolltrigger
         * @returns {ScrollTrigger.Vars} element's scrolltrigger config
         */
        getScrollTriggerConfig: function (slideEl) {
            const isFirst = [...slideEl.parentElement.children].indexOf(slideEl) === 0;
            return Object.assign({}, this._super(slideEl), {
                start: () => !isFirst ? 'top top+=10%' : 'top center',
                end: () => 'bottom center-=10%'
            });
        }
    });
});
